import React from "react"

import './style.scss';

const TableOfContents = ({ content }) => {
    return content ? (
        <div className="table-of-contents-wrapper">
            <h3 className="toc-h3">Table Of Contents</h3>
            <div
                className="table-of-contents"
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </div>
    ) : null;
}

export default TableOfContents;